<template>
  <d-container fluid class="main-content-container p-4">
    <div>
      <!-- COLLAPSE-->
      <b-button v-b-toggle.collapsible-filters class="m-1 greenbutton">
        <i class="fas fa-filter mr-2 "></i> Période
      </b-button>
      <!-- Element to collapse -->
      <b-collapse id="collapsible-filters" class="mb-4">
        <d-card class="card-small">
          <d-card-body class="pb-0">
            <d-input-group class="justify-content-center">
              <label class="font-weight-bold mr-1 mt-2">Du</label>
              <c-input type="date" class="mr-5" v-model="startDate"/>
              <label class="font-weight-bold mr-1 mt-2">Au</label>
              <c-input type="date" class="mr-5" v-model="endDate"/>
              <c-button-spinner class="inline-btn" variant="primary" :fetching="fetchingData" @click="refreshData">
                <template slot="icon">
                  <i class="fa fa-search"></i>
                </template>
                Appliquer
              </c-button-spinner>
            </d-input-group>
          </d-card-body>
        </d-card>
      </b-collapse>
    </div>
    <d-row>
      <d-col cols="12" lg="4" md="6" v-for="(indicator, i) in indicators" :key="i" class="mb-4">
        <d-card class="card card-small">
          <d-card-body class="text-center">
            <span class="indicator-label">
              <i :class="indicator.icon"></i> {{ indicator.label }}
            </span>
            <div v-if="fetchingData" class="mt-2">
              <b-spinner :variant="indicator.danger ? 'danger' : 'primary'"/>
            </div>
            <h6 v-else class="indicator mt-3" :class="{'indicator-danger': indicator.danger}">
              {{ indicator.value }}
            </h6>
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
    <d-row>
      <d-col class="mb-4">
        <d-card class="card card-small">
          <d-card-body class="text-center">
            <span class="indicator-label">
              <i class="fa fa-check"></i> Solde opérateurs
            </span>
            <div v-if="fetchingData" class="mt-2">
              <b-spinner variant="success" style="width: 3rem; height: 3rem;"/>
            </div>
            <div v-else>
              <h6 class="indicator indicator-success mt-3 mb-4">{{ activeBalance.value }} <small>XAF</small></h6>
              <table class="table text-secondary">
                <tbody>
                <tr v-for="operator in activeBalance.operators" :key="operator.id">
                  <td>
                    <d-image :src="operator.logo" height="24"/>
                  </td>
                  <td>{{ operator.name }}</td>
                  <td>{{ operator.balance }} <small>XAF</small></td>
                </tr>
                <tr v-if="!activeBalance.operators.length">
                  <td>Aucun opérateur trouvé</td>
                </tr>
                </tbody>
              </table>
            </div>
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import {Api, asset, formatAmount} from "@/helpers"

export default {
  title: "Vue d'ensemble",
  data() {
    return {
      startDate: "",
      endDate: "",
      fetchingData: false,
      data: null
    }
  },
  computed: {
    indicators() {
      return [
        {
          icon: "fa fa-user",
          label: "Utilisateurs",
          value: this.data ? formatAmount(this.data.users.total) : "---"
        },
        {
          icon: "fa fa-briefcase",
          label: "Marchands",
          value: this.data ? formatAmount(this.data.users.merchant) : "---"
        },
        {
          icon: "fa fa-shopping-cart",
          label: "Services",
          value: this.data ? formatAmount(this.data.services.total) : "---"
        },
        {
          icon: "fa fa-exchange-alt",
          label: "Volume transactions",
          value: this.data ? formatAmount(this.data.transactions.volume) : "---"
        },
        {
          icon: "fa fa-exchange-alt",
          label: "Commissions",
          value: this.data ? formatAmount(this.data.transactions.commissions) : "---"
        },
        {
          icon: "fa fa-exchange-alt",
          label: "Frais",
          value: this.data ? formatAmount(this.data.transactions.fees) : "---"
        },
        {
          icon: "fa fa-exchange-alt",
          label: "Transactions",
          value: this.data ? formatAmount(this.data.transactions.total) : "---"
        },
        {
          icon: "fa fa-dollar-sign",
          label: "Marge",
          value: this.data ? formatAmount(this.data.transactions.income) : "---"
        },
        {
          icon: "fa fa-th-large",
          label: "Solde des Services",
          value: this.passiveBalance.services,
          danger: true,
        },
      ]
    },
    activeBalance() {
      const operators = this.data ? this.data.operators : null
      return {
        value: operators
          ? formatAmount(operators.reduce((acc, op) => acc + Number(op.balance), 0))
          : "---",
        operators: operators.map(op => ({
          ...op,
          logo: asset(op.logo),
          balance: op.balance === null ? '---' : formatAmount(op.balance)
        })) || []
      }
    },
    passiveBalance() {
      const balance = this.data ? this.data.balance : null
      return {services: balance ? formatAmount(balance.service) : "---"}
    },
  },
  created() {
    this.refreshData()
  },
  methods: {
    refreshData() {
      this.fetchingData = true
      Api.get("/indicators/all", {
        start_date: this.startDate,
        end_date: this.endDate,
      })
        .then(res => this.data = res.data)
        .catch(err => this.error = err)
        .then(() => this.fetchingData = false)
    }
  }
}
</script>

<style scoped>
.indicator-label {
  color: #838383;
  text-transform: uppercase;
  letter-spacing: 0.0625rem;
  font-size: 12px;
}

.indicator {
  color: #00578A;
  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-size: 2.0625rem;
}

.indicator-success {
  color: #3CBE0A;
}

.indicator-danger {
  color: #EC3C3C;
}
</style>
